export interface Tag {
  uuid: string;
  name: string;
  notes: string;
  color: string;
  isGlobal: number;
  quantity: number;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface TagsListMeta {
  currentPage: number;
  perPage: number;
  total: number;
  totalPages: number;
}

export interface TagsListResponse {
  data: Tag[];
  meta: TagsListMeta;
}

export const DEFAULT_TAGS_CURRENT_PAGE = 1;
export const DEFAULT_TAGS_PER_PAGE = 25;
export const TAGS_PAGE_SIZE_OPTIONS = [DEFAULT_TAGS_PER_PAGE, 50, 100] as const;

export interface TagSubmitPayload {
  uuid?: string;
  name: string;
  notes?: string;
  color: string;
  isGlobal: number;
}

export const TAG_COLORS: string[] = [
  '#57BDAD',
  '#3699C0',
  '#F4885C',
  '#E95A70',
  '#D09600',
  '#786EEE',
];

export function getTagColorIndex(hex: string | undefined | null): number {
  if (!hex) {
    return -1;
  }
  const normalized = hex.startsWith('#') ? hex.toLowerCase() : `#${hex.toLowerCase()}`;

  return TAG_COLORS.findIndex((color) => color.toLowerCase() === normalized);
}

